import type { FunctionComponent, ReactNode } from 'react';

import { usePersonalProductivityCohortValue } from 'app/src/components/PersonalProductivityBeta';
import { PlanComparisonHeader as Headers } from './PlanComparisonHeader';
import { PlanComparisonRow as Rows } from './PlanComparisonRow';
import { PlanComparisonTotals } from './PlanComparisonTotals';
import type { FeatureItem } from './useFeatures';
import { useFeatures } from './useFeatures';
import { usePersonalProductivityFeatures } from './usePersonalProductivityFeatures';

import * as styles from './PlanComparison.module.less';

interface OwnProps {
  isEligibleForTrial: boolean;
  isMonthly: boolean;
  numOfMembers?: number;
  teamId: string;
  teamDisplayName: ReactNode;
  teamName: string;
  onShowFreeTrialModal: (planName: string) => void;
}
export const PlanComparison: FunctionComponent<OwnProps> = ({
  isEligibleForTrial,
  isMonthly,
  numOfMembers,
  teamId,
  teamDisplayName,
  teamName,
  onShowFreeTrialModal,
}) => {
  const personalProductivityCohort = usePersonalProductivityCohortValue();
  const isInPPCohort =
    personalProductivityCohort === 'ga' ||
    personalProductivityCohort === 'opted_in';
  const features = useFeatures();
  const personalProductivityFeatures = usePersonalProductivityFeatures();

  const featuresToDisplay = isInPPCohort
    ? personalProductivityFeatures
    : features;
  return (
    <section className={styles.container}>
      <table>
        <Headers
          isEligibleForTrial={isEligibleForTrial}
          teamId={teamId}
          teamName={teamName}
          isMonthly={isMonthly}
          onShowFreeTrialModal={onShowFreeTrialModal}
          isInPPCohort={isInPPCohort}
        />
        <tbody>
          {featuresToDisplay.map((featureItem: FeatureItem) => (
            <Rows featureItem={featureItem} key={featureItem.key} />
          ))}
        </tbody>
        <tfoot>
          <PlanComparisonTotals
            teamId={teamId}
            numOfMembers={numOfMembers}
            teamName={teamDisplayName}
            isMonthly={isMonthly}
          />
        </tfoot>
      </table>
    </section>
  );
};
